import axios from "axios";
import store from "@/store";

export const printersService = {
	getPrinters,
	createPrinter,
	deletePrinter,
	editPrinter,
	getSinglePrinters,
	checkPrintFileExistence,
	printExistingFiles,
	printRunnerChit,
	printCheck,
	printTest,
	printReport,
	getWebPrintLicence,
	getWebPrintInvoiceFile,
	getWebPrintRunnerChitFile,
	getWebPrintTest,
	getWebPrintReportFinancial,
	getWebPrintReportOpenChecks,
	getWebPrintReportClosedChecks
}

function getPrinters(data) {
	return axios.get(
			`/printers`, {
				params:data
			}).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function getSinglePrinters(id) {
	return axios.get(
			`/printers/${id}`).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function createPrinter(data) {
	return axios.post(
			`/printers`, data).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function editPrinter(data, id) {
	return axios.put(
			`/printers/${id}`, data).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function deletePrinter(id) {
	return axios.delete(
			`/printers/${id}`).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function checkPrintFileExistence(){
	return axios.get(
			`${store.state.PRINT_SERVICE_API_BASE}/print/file/exist`,{
				params: {
					pos_id: store.state.auth.posId
				}
			}).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function printExistingFiles() {
	return axios.get(
			`${store.state.PRINT_SERVICE_API_BASE}/print/file`,{
				params: {
					pos_id: store.state.auth.posId
				}
			}).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function printRunnerChit(data) {
	return axios.post(
			`${store.state.PRINT_SERVICE_API_BASE}/print`,{
				type: 'runner-chit',
				order_id: data
			}).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function printCheck(data) {
	return axios.post(
			`${store.state.PRINT_SERVICE_API_BASE}/print`,{
				type: 'invoice',
				order_id: data
			}).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function printReport(data) {
	return axios.post(
		`${store.state.PRINT_SERVICE_API_BASE}/print`, data).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function printTest(data) {
	return axios.post(
			`${store.state.PRINT_SERVICE_API_BASE}/print`,{
				type: 'test',
				printer: data
			}).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

//WEB SERVICE

function getWebPrintLicence(data) {
	return axios.get(
			`/web-print/license`, {
				params:data
			}).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function getWebPrintRunnerChitFile(id) {
	return axios.get(
			`/web-print/orders/${id}/runner-chit`, {
				params:id
			}).then((res) => {
		return res
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function getWebPrintInvoiceFile(id, format) {
	const params = {};

	if (format) {
		params['format'] = format;
	}

	return axios.get(
			`/web-print/orders/${id}/invoice`, {
				params: params,
			}).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function getWebPrintTest(data) {
	return axios.get(
			`/web-print/test-page`, {
				params:data
			}).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function getWebPrintReportFinancial(data) {
	//data : department_id, terminal_id, employee_id, / business_day_id, business_days[]
	return axios.get(
			`/web-print/reports/financial`, {
				params:data
			}).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function getWebPrintReportOpenChecks(data) {
	//data : department_id, terminal_id, employee_id
	return axios.get(
			`/web-print/reports/open-checks`, {
				params:data
			}).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function getWebPrintReportClosedChecks(data) {
	//data : department_id, terminal_id, employee_id, from_date, to_date
	return axios.get(
			`/web-print/reports/closed-checks`, {
				params:data
			}).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}